import React, { useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import http from "./../../Services/http";
import Input from "./../Input/Input";
import user_preview from "./../../Media/signup/user_preview.svg";
import signup__img from "./../../Media/signup/signup.svg";
import Loader from "react-loader-spinner";
import "./Signup.css";

const signupSchema = Yup.object().shape({
  name: Yup.string()
    .min(4, "name can not be less than 4 letters")
    .required("name can not be empty"),
  email: Yup.string().email().required("email can not be empty"),
  password: Yup.string()
    .min(4, "password can not be less than 4 letters")
    .required("password can not be empty"),
  image: Yup.string().required("please select an image"),
});

const Signup = () => {
  const [image, setImage] = useState();
  const [serverErrors, setServerErros] = useState();
  const [loading, setLoading] = useState(false);
  const signupUser = async (values) => {
    const user = new FormData();
    user.append("name", values.name);
    user.append("email", values.email);
    user.append("password", values.password);
    user.append("userImage", values.image);

    try {
      setLoading(true);
      const { data } = await http.post("/users/signup", user);

      localStorage.setItem("token", data.user);
      window.location = "/";
    } catch (error) {
      setLoading(false);
      setServerErros(error.response.data);
    }
  };

  const handleImagePreview = (e, setValue) => {
    setValue("image", e.currentTarget.files[0]);
    const file = e.currentTarget.files[0];
    if (!file) {
      setImage(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setImage(objectUrl);
  };

  if (loading)
    return <Loader type="ThreeDots" color="#ef92c8" height={200} width={200} />;

  return (
    <div className="signup">
      <div className="signup__content">
        <h2 className="signup__title">Create New Account</h2>
        <Formik
          initialValues={{
            name: "",
            email: "",
            password: "",
            image: "",
          }}
          validationSchema={signupSchema}
          onSubmit={signupUser}
        >
          {({
            errors,
            handleChange,
            values,
            handleSubmit,
            setFieldValue,
            touched,
          }) => (
            <Form className="form">
              <div className={serverErrors ? "error" : null}>
                {serverErrors}
              </div>
              <Input
                value={values.name}
                onchange={handleChange}
                error={touched.name && errors.name}
                name="name"
                type="text"
                placeholder="enter your name"
              />

              <Input
                value={values.email}
                onchange={handleChange}
                error={touched.password && errors.email}
                name="email"
                type="email"
                placeholder="enter your email"
              />

              <Input
                value={values.password}
                onchange={handleChange}
                error={touched.password && errors.password}
                name="password"
                type="password"
                placeholder="enter your password"
              />

              <Input
                // value={values.image}
                onchange={(e) => handleImagePreview(e, setFieldValue)}
                error={touched.image && errors.image}
                name="image"
                type="file"
              />

              <div className="user__image__signup--container">
                <img
                  src={image || user_preview}
                  alt="user"
                  className="user__image__signup"
                />
              </div>

              <div className="wrap__button">
                <button className="submit" type="submit" onClick={handleSubmit}>
                  Signup
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className="signup__img--container">
        <img
          className="signup__img"
          src={signup__img}
          alt="signup"
          draggable={false}
        />
      </div>
    </div>
  );
};

export default Signup;
